// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comment-grayBody___5063d46a808542a8348{color:#535366}.Comment-reply___4dc6cc249e778242dda{margin-top:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grayBody": "Comment-grayBody___5063d46a808542a8348",
	"reply": "Comment-reply___4dc6cc249e778242dda"
};
export default ___CSS_LOADER_EXPORT___;
